import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-ui-webpack/react-ui-webpack/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Avatar } from '../..';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "avatar"
    }}>{`Avatar`}</h1>
    <h2 {...{
      "id": "图片"
    }}>{`图片`}</h2>
    <Playground __position={0} __code={'() => {\n  return (\n    <Avatar src=\"https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png\" />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Avatar,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        return <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" mdxType="Avatar" />;
      }}
    </Playground>
    <h2 {...{
      "id": "文字"
    }}>{`文字`}</h2>
    <Playground __position={1} __code={'() => {\n  return <Avatar>SONGJP</Avatar>\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Avatar,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        return <Avatar mdxType="Avatar">SONGJP</Avatar>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      